import InputBlock from "./InputBlock";
import DbAutocomplete from "../autocomplete/DbAutocomplete";

import { useOfficesWithCurrentChanges } from "../../../helpers/components/offices";

const OfficeInput = ({
  office,
  setOffice,
  transactionSubcategory,
  availableOffices,
  title = "Tag an office for this transaction",
  ...otherProps
}) => {
  const [offices] = useOfficesWithCurrentChanges();

  const filterOffices = () => {
    if (!offices.length) {
      return [];
    }

    return offices.filter(({ endDate, currentUtilities, utilitiesConfig }) => {
      const {
        electricityInLease,
        heatInLease,
        hasHeat,
        combinedUtility,
      } = currentUtilities || {};

      if (
        !endDate &&
        !["electricity", "gas", "utilities"].includes(transactionSubcategory)
      ) {
        return true;
      }

      if (endDate) {
        return false;
      }

      if (transactionSubcategory === "utilities") {
        const powerNotInLease = electricityInLease !== true;
        const heatNotInLease = hasHeat !== false && heatInLease !== true;
        return (
          (combinedUtility || utilitiesConfig === "combinedUtilities") &&
          powerNotInLease &&
          heatNotInLease
        );
      }

      if (transactionSubcategory === "gas") {
        return hasHeat !== false;
      }

      if (transactionSubcategory === "electricity") {
        return true;
      }

      return true;
    });
  };

  const filteredOffices = filterOffices();

  return (
    <InputBlock type="offices" title={title} cardData={office} {...otherProps}>
      <DbAutocomplete
        collection="offices"
        setValue={setOffice}
        value={office}
        queries={[["type", "==", "companyOffice"]]}
        availableOptions={availableOffices || filteredOffices}
        id="office-tag-input"
      />
    </InputBlock>
  );
};
export default OfficeInput;
